import logoTruck from './IconImg/logoTruck.png'
import left from './IconImg/left.png'
import right from './IconImg/right.png'
import avatar from './IconImg/avatar.jpg'
import tsa from './IconImg/tsa.png'
import robot from './IconImg/robot.png'
export const IconImg = {
  logoTruck,
  left,
  right,
  avatar,
  tsa,
  robot
}